"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const regex_js_1 = require("./regex.js");
function validate(uuid) {
    return typeof uuid === 'string' && regex_js_1.default.test(uuid);
}
exports.default = validate;
